import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import allowUpAndDownOnEdit from '_legacy/components/grid/columnDefaults/allowUpAndDownOnEdit';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';

const cleanDirtyCargoHeading = {
    colId: 'cleanDirtyCargo',
    headerName: 'C/D',
    field: 'cleanDirtyCargo',
    editable: true,
    cellEditorFramework: SelectEditor,
    cellEditorParams: {
        values: ['', 'C', 'D'],
    },
    supressKeyboardEvent: allowUpAndDownOnEdit(),
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
    },
    width: 60,
    hide: true,
};

export default cleanDirtyCargoHeading;
